import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import {
  selectActiveSession,
  selectSelectedSchoolId,
} from "app/modules/schools/selectors";
import {
  CustomSelectBox,
  CustomTextField,
} from "assets/styles/globalStyledComponent";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ErrorText from "../CreateStudent/components/ErrorText";
import { DatePicker } from "@mui/x-date-pickers";
import { bulkPromoteByClass } from "app/services/schoolService/studentBulk.service";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Info } from "@mui/icons-material";
import { getAllSessions } from "app/services/management";
import { useClassData } from "app/hooks/globallyApplicable/useClassData";

const BulkPromotion = () => {
  const schoolDocId = useSelector(selectSelectedSchoolId);
  const selectedSession = useSelector(selectActiveSession);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [state, setState] = React.useState({
    sections: [],
    toSections: [],
    open: false,
    confirmDialogOpen: false,
    formData: null,
  });
  const [nextSession, setNextSession] = React.useState("");
  const [nextSessionError, setNextSessionError] = React.useState("");

  const initialState = {
    fromClassDocId: "",
    fromSection: "",
    admissionDate: new Date(),
    toClassDocId: "",
    toSection: "",
  };

  const { control, watch, handleSubmit, reset } = useForm({
    defaultValues: initialState,
    mode: "onBlur",
  });

  const { data: allSessionsResponse } = useQuery({
    queryKey: ["getAllSessions", schoolDocId],
    queryFn: () => getAllSessions(schoolDocId),
    enabled: !!schoolDocId,
    onError: (err) => toast.error(err?.response?.data?.message),
  });
  const allSessions = allSessionsResponse?.data?.list || [];

  const { classList: classData, error: classDataError } = useClassData();
  useEffect(() => {
    if (classDataError) {
      toast.error(classDataError?.response?.data?.message);
    }
  }, [classDataError]);

  const {
    mutate: bulkPromoteByClassMutate,
    isLoading: bulkPromoteByClassLoading,
  } = useMutation(bulkPromoteByClass, {
    onSuccess: ({ data }) => {
      handleConfirmDialogClose();
      handleReset();
      toast.success(data?.message);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const CustomSelect = ({ control, name, rules, options = [] }) => {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <CustomSelectBox
            native
            size="small"
            fullWidth
            displayEmpty
            onChange={onChange}
            value={value}
            error={!!error}
          >
            <MenuItem value={""} component="option">
              <em>Select</em>
            </MenuItem>
            {options?.map((item) => (
              <MenuItem value={item} key={item} component="option">
                {item}
              </MenuItem>
            ))}
          </CustomSelectBox>
        )}
      />
    );
  };
  const CustomDatePicker = ({ control, name, rules }) => {
    return (
      control && (
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <DatePicker
              inputFormat="DD-MM-YYYY"
              onChange={(e) => onChange(e)}
              value={value}
              renderInput={(params) => (
                <CustomTextField {...params} size="small" fullWidth />
              )}
            />
          )}
        />
      )
    );
  };

  const currentSessionBox = () => {
    return (
      <>
        <Grid
          container
          spacing={1}
          sx={{
            padding: "2",
            marginTop: "16px",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <Grid item xs={12}>
            <TextFieldLabel
              title={`Current Session : ${selectedSession}`}
              styleProps={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            />
            <Divider
              sx={{
                marginBottom: "16px",
                borderColor: "#e0e0e0",
                borderWidth: "1px",
                borderStyle: "solid",
                width: "100%",
                backgroundColor: "black",
                height: "1px",
              }}
            />
          </Grid>
          <Grid item xs={6} p={2}>
            <TextFieldLabel title={"Class Stream"} required />
            <Controller
              control={control}
              rules={{
                required: "Class required",
              }}
              render={({
                field: { onChange, onBlur, value },
                fieldState: { error },
              }) => (
                <>
                  <CustomSelectBox
                    native
                    displayEmpty
                    fullWidth
                    size="small"
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value}
                    error={!!error}
                  >
                    <MenuItem value="" component="option">
                      Select
                    </MenuItem>
                    {classData?.map((item) => (
                      <MenuItem
                        component="option"
                        key={item?.classDocId}
                        value={item?.classDocId}
                      >
                        {item?.className_stream}
                      </MenuItem>
                    ))}
                  </CustomSelectBox>
                  {!!error && <ErrorText text={error?.message} />}
                </>
              )}
              name="fromClassDocId"
            />
          </Grid>
          <Grid item xs={6} p={2}>
            <TextFieldLabel title={"Section"} required />
            <CustomSelect
              control={control}
              name="fromSection"
              rules={{ required: "Section required" }}
              options={state?.sections ?? []}
            />
          </Grid>
        </Grid>
      </>
    );
  };
  const nextSessionBox = () => {
    return (
      <>
        <Grid
          container
          spacing={1}
          sx={{
            padding: "2",
            marginTop: "16px",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <Grid item xs={12}>
            {/* <TextFieldLabel
              title={`Next Session :- ${
                parseInt(selectedSession?.split("-")[0]) +
                1 +
                "-" +
                (parseInt(selectedSession?.split("-")[1]) + 1)
              }`}
              styleProps={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            /> */}
            <Stack direction="row" alignItems="center" gap={2}>
              <TextFieldLabel title={`Next Session : `} />
              <CustomSelectBox
                native
                size="small"
                displayEmpty
                value={nextSession}
                onChange={(e) => {
                  setNextSession(e.target.value);
                  setNextSessionError("");
                }}
                sx={{ minWidth: 150 }}
              >
                <MenuItem value="" component="option">
                  <em>Select</em>
                </MenuItem>
                {allSessions.map((s) => (
                  <MenuItem
                    key={s._id}
                    value={s.sessionName}
                    component="option"
                  >
                    {s.sessionName}
                  </MenuItem>
                ))}
              </CustomSelectBox>
            </Stack>
            {nextSessionError && (
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {nextSessionError}
              </Typography>
            )}
            <Divider
              sx={{
                marginTop: "8px",
                marginBottom: "16px",
                borderColor: "#e0e0e0",
                borderWidth: "1px",
                borderStyle: "solid",
                width: "100%",
                backgroundColor: "black",
                height: "1px",
              }}
            />
          </Grid>
          <Grid item xs={4} p={2}>
            <TextFieldLabel title={"Admission Date"} required />
            <CustomDatePicker
              control={control}
              name="admissionDate"
              rules={{
                required: "Admission Date required",
              }}
            />
          </Grid>
          <Grid item xs={4} p={2}>
            <TextFieldLabel title={"Class Stream"} required />
            <Controller
              control={control}
              rules={{
                required: "Class required",
              }}
              render={({
                field: { onChange, onBlur, value },
                fieldState: { error },
              }) => (
                <>
                  <CustomSelectBox
                    native
                    displayEmpty
                    fullWidth
                    size="small"
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value}
                    error={!!error}
                  >
                    <MenuItem value="" component="option">
                      Select
                    </MenuItem>
                    {classData?.map((item) => (
                      <MenuItem
                        component="option"
                        key={item?.classDocId}
                        value={item?.classDocId}
                      >
                        {item?.className_stream}
                      </MenuItem>
                    ))}
                  </CustomSelectBox>
                  {!!error && <ErrorText text={error?.message} />}
                </>
              )}
              name="toClassDocId"
            />
          </Grid>
          <Grid item xs={4} p={2}>
            <TextFieldLabel title={"Section"} required />
            <CustomSelect
              control={control}
              name="toSection"
              rules={{ required: "Section required" }}
              options={state?.toSections ?? []}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  useEffect(() => {
    const selectedClass = watch("fromClassDocId");
    if (selectedClass) {
      const selectedSections = classData?.find(
        (item) => item.classDocId === selectedClass,
      )?.sections;
      setState((prev) => ({
        ...prev,
        sections: selectedSections,
      }));
    }
  }, [classData, watch("fromClassDocId")]);

  useEffect(() => {
    if (watch("toClassDocId")) {
      const toSections = classData?.find(
        (item) => item?.classDocId === watch("toClassDocId"),
      )?.sections;

      setState((prev) => ({
        ...prev,
        toSections: toSections,
      }));
    }
  }, [classData, watch("toClassDocId")]);
  const handleConfirmDialogOpen = (data) => {
    setState((prev) => ({ ...prev, confirmDialogOpen: true, formData: data }));
  };

  const handleConfirmDialogClose = () => {
    setState((prev) => ({ ...prev, confirmDialogOpen: false }));
  };

  const handleConfirmPromotion = () => {
    if (!nextSession) {
      setNextSessionError("Please select the next session");
      return;
    }
    if (state.formData) {
      const payload = {
        fromClass: {
          session: selectedSession,
          classDocId: state.formData.fromClassDocId,
          section: state.formData.fromSection,
        },
        toClass: {
          session: nextSession,
          admissionDate: state.formData.admissionDate
            ? new Date(state.formData.admissionDate)
            : null,
          classDocId: state.formData.toClassDocId,
          section: state.formData.toSection,
        },
      };
      bulkPromoteByClassMutate(payload);
    }
  };

  const handleReset = () => {
    reset(initialState);
  };

  return (
    <>
      {/* <CustomLinearProgress
        loading={getClassDropdownFetching || getClassDropdownLoading}
      /> */}

      <Dialog
        open={state.confirmDialogOpen}
        onClose={() => handleConfirmDialogClose()}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: "10px",
            padding: "20px",
            backgroundColor: "#ffffff",
            boxShadow: 3,
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Grid2 container spacing={2}>
            <Grid2
              size={{ xs: 12, md: 12 }}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Info
                sx={{
                  fontSize: "50px",
                  color: "secondary",
                  marginBottom: 2,
                  textAlign: "center",
                  alignSelf: "center",
                  justifySelf: "center",
                  display: "flex",
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: "#0C2F49",
                  textAlign: "center",
                }}
              >
                Promote
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: "#0C2F49",
                  textAlign: "center",
                  marginTop: 2,
                }}
              >
                Are you sure you want to promote?
              </Typography>
            </Grid2>
          </Grid2>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              handleConfirmDialogClose();
            }}
            sx={{
              width: "100%",
              marginTop: 2,
              borderRadius: "40px",
              backgroundColor: "primary",
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={bulkPromoteByClassLoading}
            variant="contained"
            color="secondary"
            onClick={() => {
              handleConfirmPromotion();
            }}
            sx={{
              width: "100%",
              marginTop: 2,
              borderRadius: "40px",
            }}
          >
            Promote
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <form
        onSubmit={handleSubmit(handleConfirmDialogOpen)}
        onReset={handleReset}
        id="bulkPromo"
      >
        <Grid
          container
          spacing={isMobile ? 0 : 4}
          sx={{ padding: isMobile ? 1 : 0 }}
        >
          <Grid item xs={isMobile ? 12 : 6}>
            {currentSessionBox()}
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            {nextSessionBox()}
          </Grid>
        </Grid>
      </form>
      <Stack
        direction="row"
        justifyContent="flex-end"
        sx={{ my: 2 }}
        spacing={2}
      >
        <Button
          variant="outlined"
          size="large"
          type="reset"
          form="bulkPromo"
          color="error"
        >
          Reset
        </Button>
        <LoadingButton
          variant="contained"
          size="large"
          color="secondary"
          type="submit"
          form="bulkPromo"
          loading={bulkPromoteByClassLoading}
        >
          Proceed
        </LoadingButton>
      </Stack>
    </>
  );
};

export default BulkPromotion;
